import React, { useState } from 'react';
import AppButton from 'src/components/base/Button/Button';
import MiniCheckBox from 'src/components/modules/MiniCheckBox/MiniCheckBox';
import './ReviewPatientTodo.scss';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useDispatch } from 'react-redux';
import { updateIfollowedUpTodo } from 'src/redux/services/loggingServices';
import { Logger } from 'src/latest/src/services/ConsoleLogger';
import { TodoTypeEnums } from 'src/latest/src/constants';
import { useTranslation } from 'react-i18next';
import { changeTodoStatusV1 } from 'src/api/user';

type Props = {
  todo: any;
  onConfirm: () => void;
};

const ReviewPatientTodo: React.FC<Props> = ({ onConfirm, todo }) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean | 'clear' | 'pending'>(false);

  const { t } = useTranslation('components');
  const dispatch = useDispatch();

const createFollowUp = async () => {
    const respObj = {
      follow_up_by: [TodoTypeEnums.SELF],
      note: ``,
    };

    try {
      setLoading('clear');
      await updateIfollowedUpTodo(todo.id, respObj);
      dispatch(clearModalContent());
      onConfirm();
    } catch (e) {
      Logger.log("Follow up error", e);
    } finally {
      setLoading(false);
    }
  };

  const markToDoAsPending = async () => {
    setLoading('pending');

    try {
      await changeTodoStatusV1(todo.id, false, "");
      onConfirm();
      dispatch(clearModalContent());
    } catch (e) {
      Logger.log("Pending error", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="review-patient-todo-container">
      <div className="description">
        {t('reviewPatientTodo.description')}
      </div>

      <div className="checkbox-container d-flex justify-content-between mt-5 mb-4">
        <MiniCheckBox
          text={t('reviewPatientTodo.checkbox')}
          isCheckFirst={true}
          isActive={checked}
          onClick={() => setChecked(!checked)}
          value={checked}
        />
      </div>

      <div className="d-flex justify-content-center mt-3">
        <AppButton
          label={t('reviewPatientTodo.clearButton')}
          textWeight="bold"
          textSize="size-14"
          isProcessing={loading === 'clear'}
          disabled={!!loading || !checked}
          className="m-2 primary no-border clear-todo-button"
          onClick={() => {
            createFollowUp();
          }}
        />

        <AppButton
          label={t('reviewPatientTodo.moveToPendingButton')}
          textWeight="bold"
          textSize="size-14"
          variant="light"
          isProcessing={loading === 'pending'}
          disabled={!!loading || todo.active === false}
          className="m-2 bg-white"
          onClick={markToDoAsPending}
        />
      </div>
    </div>
  );
};

export default ReviewPatientTodo;
